import { default as _91_46_46_46pageResolver_93jLZj2473kbMeta } from "/builds/proverky/proverky.net/frontend/pages/[...pageResolver].vue?macro=true";
import { default as thanksmz8MuVfWZaMeta } from "/builds/proverky/proverky.net/frontend/pages/thanks.vue?macro=true";
export default [
  {
    name: "pageResolver",
    path: "/:pageResolver(.*)*",
    component: () => import("/builds/proverky/proverky.net/frontend/pages/[...pageResolver].vue").then(m => m.default || m)
  },
  {
    name: "thanks",
    path: "/thanks",
    component: () => import("/builds/proverky/proverky.net/frontend/pages/thanks.vue").then(m => m.default || m)
  }
]